'use strict';

exports.__esModule = true;
exports.default = isInvalidAnimate;
var gcc = 'getComposedComponent';

/**
 * Just checks if the fab is actually a ref to the FAB Button.
 */
function isInvalidAnimate(fab) {
  return typeof fab[gcc] !== 'function' || typeof fab[gcc]()[gcc] !== 'function' || typeof fab[gcc]()[gcc]()._animateForSnackbar !== 'function';
}


//////////////////
// WEBPACK FOOTER
// ./~/react-md/lib/Snackbars/isInvalidAnimate.js
// module id = 124
// module chunks = 213130420965792 213534597649335